(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifPagination', swifPagination);


    /**
    * @ngdoc directive
    * @name swif.ui:swifPagination
    * @module swif.ui
    * @restrict E
    * @description provide pagination to collections
    **/
    function swifPagination(swif) {
        'ngInject';
        var template = '<div ng-show="displayPagination"><uib-pagination class="pull-right" ';
        template += 'total-items="totalItems" ng-model="proxy" ';
        template += 'items-per-page="itemsPerPage" ';
        template += 'previous-text="{{\'Previous\' | translate}}" ';
        template += 'next-text="{{\'Next\' | translate}}" ';
        template += 'max-size="3" rotate="false"></uib-pagination></div>';
        return {
            restrict: 'E',
            replace: true,
            require: 'ngModel',
            scope: {
                'totalItems': '=?',
                'itemsPerPage': '=?',
                'swifChange': '&?'
            },
            link: function (scope, element, attrs, ngModel) {
                scope.displayPagination = false;
                ngModel.$render = function () {
                    var vv = ngModel.$viewValue;
                    if (typeof vv === 'object' && vv.hasOwnProperty('currentFilter')) {
                        scope.collection = vv;
                        scope.totalItems = vv.currentCount;
                        scope.itemsPerPage = vv.currentFilter.limit;
                        scope.proxy = vv.currentPage;
                    } else {
                        scope.proxy = vv;
                    }
                };
                swif.form.wrapNgModelWithOnchange(scope, ngModel);
                scope.$watch('collection', function (newV) {
                    if (!newV) {
                        return;
                    }
                    scope.totalItems = newV.currentCount;
                    scope.itemsPerPage = newV.currentFilter.limit;
                    if (scope.proxy !== newV.currentPage) {
                        scope.proxy = newV.currentPage;
                    }
                }, true);
                scope.$watch('proxy', function (newV) {
                    var vv = ngModel.$viewValue;
                    if (typeof vv === 'object') {
                        if (!_.isEqual(vv.currentPage, newV)) {
                            vv.currentPage = newV;
                            ngModel.$setViewValue(vv);
                        }
                    } else {
                        ngModel.$setViewValue(newV);
//                        scope.$parent.$eval(attrs.ngChange);
                    }
                });
                scope.$watch('totalItems', function () {
                    scope.displayPagination = scope.totalItems > scope.itemsPerPage || false;
                });
            },
            template: template
        };
    }

})();
